import React from 'react'
import * as Icons from 'react-bootstrap-icons'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { LinkLayout } from '../../../../../../Shared/Frontend/utils/links'
import { slugify } from '../../../../../../Shared/Frontend/utils/slugify'
import { ActionProps } from '../../modernBlocks.state'
import { SharedBlockLayout } from '../shared/sharedBlock.layout'
import { LinkGridBlockClassNames, LinkGridItemProps } from './gridBlock.state'
import { htmlDecode } from '../../../utils/html'

export const linkGridBlockClasses: LinkGridBlockClassNames = {
  // DEFAULTS
  block: 'block block--grid',
  inview: 'inview',
  inner: 'block__inner ls-gutter ls-spacing--s',
  header: 'block__header ls-container--nogut',
  label: 'block__label text--s',
  title: 'block__title title--m',
  intro: 'block__intro text--l',
  content: 'block__content ls-container--l-nogut',
  footer: 'block__footer ls-clickables',
  clickableWrapper: 'block__action ls-clickable',
  clickablePrimary: 'block__button button button--primary',
  clickableSecondary: 'block__button button button--tertiary',
  clickablePrimaryLabel: 'button__label',
  clickableSecondaryLabel: 'button__label',

  // BLOCK SPECIFIC
  blockText: 'block--grid-text',
  blockImage: 'block--grid-image',
  blockIcon: 'block--grid-icon',
  list: 'grid',
  item: 'grid__item',
  itemInner: 'grid__inner',
  itemText: 'grid__content',
  itemTitle: 'grid__title title--s',
  itemIntro: 'grid__intro',
  itemLabel: 'grid__label text--s',
  itemVisual: 'grid__visual',
  itemImage: 'grid__image',
  itemIconVisual: 'grid__visual-icon',
  itemIcon: 'grid__icon',
  itemLink: 'grid__link',
  itemFauxLink: 'grid__fauxlink',
  itemFauxLinkText: 'grid__fauxlabel',
}

export const LinkGridBlockLayout = {
  GetGridIcon: (id: number): string => {
    let iconSlug: string = ''
    if (id == 1) {
      iconSlug = 'innovate'
    } else if (id == 2) {
      iconSlug = 'leader'
    } else if (id == 3) {
      iconSlug = 'insights'
    }
    return ``
  },
  Content: (
    props: {
      label?: string
      title?: string
      intro?: string
      items: LinkGridItemProps[]
    } & ActionProps
  ) => {
    const { intro, items, label, showPrimary, showSecondary, primaryAction, secondaryAction, title } = props
    return (
      <div className={getClassNameModern(linkGridBlockClasses, 'inner', 'mw-container-l mx-auto px-gutter')}>
        {(label || title || intro) && (
          <header className={getClassNameModern(linkGridBlockClasses, 'header', 'mw-container-s mb-5')}>
            {label && (
              <p className={getClassNameModern(linkGridBlockClasses, 'label', 'fs-6 text-primary text-uppercase')}>
                {label}
              </p>
            )}
            {title && <h2 id={slugify(htmlDecode(title))} className={getClassNameModern(linkGridBlockClasses, 'title', '')}>{title}</h2>}
            {intro && (
              <div
                className={getClassNameModern(linkGridBlockClasses, 'intro', '')}
                dangerouslySetInnerHTML={{ __html: intro }}
              />
            )}
          </header>
        )}

        <div className={getClassNameModern(linkGridBlockClasses, 'content', '')}>
          <LinkGridBlockLayout.GridList items={items} />
        </div>

        {(showPrimary || showSecondary) && (
          <footer className='block__actions ls-container--nogut'>
            <div className={getClassNameModern(linkGridBlockClasses, 'footer', 'pt-5 text-center')}>
              <div className={getClassNameModern(linkGridBlockClasses, 'clickableWrapper', 'd-block d-sm-inline-block')}>
                {showPrimary && primaryAction && primaryAction.title && primaryAction.url && (
                  <SharedBlockLayout.Clickable
                    type="button"
                    id={`gridPrimaryAction${primaryAction.url}`}
                    link={primaryAction}
                    classNames={getClassNameModern(linkGridBlockClasses, 'clickablePrimary', 'btn btn-primary')}
                  />
                )}
              </div>
              <div
                className={getClassNameModern(
                  linkGridBlockClasses,
                  'clickableWrapper',
                  'd-block d-sm-inline-block ms-sm-3 mt-3 mt-sm-0'
                )}
              >
                {showSecondary && secondaryAction && secondaryAction.title && secondaryAction.url && (
                  <SharedBlockLayout.Clickable
                    type="button"
                    id={`gridSecondaryAction${secondaryAction.url}`}
                    link={secondaryAction}
                    classNames={getClassNameModern(linkGridBlockClasses, 'clickableSecondary', 'btn btn-outline-primary')}
                  />
                )}
              </div>
            </div>
          </footer>
        )}
      </div>
    )
  },
  GridList: (props: { items: LinkGridItemProps[] }) => {
    const { items } = props
    return (
      <ul className={getClassNameModern(linkGridBlockClasses, 'list', 'row')}>
        {items.map((innerItem, index) => {
          return (
            <li
              key={`${index}-${innerItem.title}`}
              className={getClassNameModern(linkGridBlockClasses, 'item', 'col-12 col-sm-6 col-lg-4')}
            >
              <article
                className={getClassNameModern(
                  linkGridBlockClasses,
                  'itemInner',
                  'bg-white text-secondary h-100 d-flex flex-column'
                )}
              >
                {innerItem.link && innerItem.link.url ? (
                  innerItem.kind === 'download' ? (
                    <a
                      download={true}
                      target='_blank'
                      rel='noopener noreferrer'
                      id={`${index}-${slugify(innerItem.title || '')}`}
                      href={innerItem.link.url}
                      className={`${getClassNameModern(linkGridBlockClasses, 'itemLink', 'h-100 d-flex flex-column')} ${(!innerItem.label && !innerItem.title && !innerItem.intro) ? 'grid__link--only' : 'grid__link--text'}`}
                    >
                      <LinkGridBlockLayout.GridItem item={innerItem} />
                    </a>
                  ) : (
                    <LinkLayout
                      id={`${index}-${slugify(innerItem.title || '')}`}
                      link={innerItem.link}
                      className={`${getClassNameModern(linkGridBlockClasses, 'itemLink', 'h-100 d-flex flex-column')} ${(!innerItem.label && !innerItem.title && !innerItem.intro) ? 'grid__link--only' : 'grid__link--text'}`}
                    >
                      <LinkGridBlockLayout.GridItem item={innerItem} />
                    </LinkLayout>
                  )
                ) : (
                  <LinkGridBlockLayout.GridItem item={innerItem} />
                )}
              </article>
            </li>
          )
        })}
      </ul>
    )
  },
  GridItem: (props: { children?: React.ReactNode; item: LinkGridItemProps }) => {
    const { item } = props
    return (
      <>
        {item?.image ? (
          <div className={getClassNameModern(linkGridBlockClasses, 'itemVisual', '')}>
            <SharedBlockLayout.ModernImageSrcSet
              image={item?.image}
              lazyload={true}
              priority={undefined}
              classNames={getClassNameModern(linkGridBlockClasses, 'itemImage', '')}
              pictureClassNames={'grid__picture'}
              imageProportions={{
                width: '420',
                height: '236',
                sizes: '(min-width: 1440px) 420px, (min-width: 1024px) 30vw, 260px'
              }}
            />
          </div>
        ) : (
          <></>
        )}

        {(item.label || item.title || item.intro) && (
          <div className={getClassNameModern(linkGridBlockClasses, 'itemText', 'p-4')}>
            {item.label && (
              <div className={getClassNameModern(linkGridBlockClasses, 'itemLabel', 'small')}>{item.label}</div>
            )}

            {item.title && (
              <h3 className={getClassNameModern(linkGridBlockClasses, 'itemTitle', 'h2 fs-1')}>{item.title}</h3>
            )}
            {item.intro && (
              <div className={getClassNameModern(linkGridBlockClasses, 'itemIntro', '')}>{item.intro}</div>
            )}
          </div>
        )}

        {item.link && item.link.url && item.link.title && (
          <div className={getClassNameModern(linkGridBlockClasses, 'itemFauxLink', 'd-none')}>
            <span className={getClassNameModern(linkGridBlockClasses, 'itemFauxLinkText', '')}>{item.link?.title}</span>
          </div>
        )}
      </>
    )
  },
}
